// extracted by mini-css-extract-plugin
module.exports = {"wrap":"dear-manager-styles-module--wrap--1X8bJ","bg":"dear-manager-styles-module--bg--2gqtP","punchout":"dear-manager-styles-module--punchout--1_rL-"};